<template>
  <div class='dataStatistics'>
    <div class="intro-y box lg" v-if="!user.adminFlag">
      <div
        class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
      >
        <h2 class="font-medium text-base mr-auto">负责的资产</h2>
        <div class="dropdown relative ml-auto buts" @click="jumpAsset()">
          全部资产
        </div>
      </div>
      <div class="grid grid-cols-12 gap-5">
        <div
          class="col-span-12 sm:col-span-4 box p-5 cursor-pointer zoom-in item"
            v-for="(item,index) in assetsList"
            :key="index"
            @click="checkHandle(item)"
        >
          <div class="item-tit">{{item.managementEnterprise}}</div>
          <div class="item-add">{{item.certificateAddress}}</div>
          <div class="footer">
            <span>{{item.assetNumber}}</span>
            <span>{{item.contractStatus}}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="intro-y box lg" v-else>
      <div
        class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
      >
        <h2 class="font-medium text-base mr-auto">数据统计</h2>
        <div class="dropdown relative ml-auto buts" @click="jumpAsset()">
          全部资产
        </div>
      </div>
      <div class="items-center total">
        <div class='items col-span-12 sm:col-span-4 xxl:col-span-3 box p-5 cursor-pointer zoom-in'>
          <div>资产管理总数</div>
          <div class="bold">{{countDate.totalAssetCount}}</div>
          <a href="javascript:;" @click="jumpAsset()">查看详情 ></a>
        </div>
        <div class='items col-span-12 sm:col-span-4 xxl:col-span-3 box p-5 cursor-pointer zoom-in'>
          <div>合同总数</div>
          <div class="bold">{{countDate.totalContractCount}}</div>
          <a href="javascript:;" @click="jumpContract()">查看详情 ></a>
        </div>
        <div class='items col-span-12 sm:col-span-4 xxl:col-span-3 box p-5 cursor-pointer zoom-in'>
          <div>租客总数</div>
          <div class="bold">{{countDate.totalLesseeCount}}</div>
          <a href="javascript:;" @click="jumpTenant()">查看详情 ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getList} from '../../../api/asset.js'
  import {getDataCount} from '../../../api/workbench.js'
  import {mapState} from 'vuex'
  export default {
    name: "dataStatistics",
    components: {},
    data() {
      return {
        countDate:{},
        assetsList:[],
        assetsLoading:false,
      }
    },
    methods: {
      checkHandle(val){
        this.$router.push({path:'/assetManagement/assetDetail',query:{assetId:val.assetId}})
      },
      jumpAsset(){
        this.$router.push({path:'/assetManagement/assetList',query:{activeSlide:'/assetManagement/assetList'}})
      },
      jumpContract(){
        this.$router.push('/contractManagement/contractList')
      },
      jumpTenant(){
        this.$router.push('/tenantManagement/tenantList')
      },
      getDataCount(){
        getDataCount({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.countDate = data.content
          } else {
            this.countDate = {}
          }
        }).catch(err => {
          console.log(err);
        })
      },
      getList(){
        let para = {
          companyId:this.user.companyId,
          page:1,
          perPage:6,
        }
        this.assetsLoading = true
        getList(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.assetsList = data.content.list
          } else {

          }
        }).catch(err => {
          console.log(err);
          this.assetsLoading = false
        }).finally(() => {
          this.assetsLoading = false
        })
      },
    },
    created() {

    },
    watch: {
      user(user) {
        if(user.adminFlag){
          this.getDataCount()
        }else{
          this.getList()
        }
      },
    },
    computed: {
      ...mapState({
        user:state=>state.user.user
      })
    }
  }
</script>

<style scoped lang="scss">
  .dataStatistics {
    width:100%;
    min-height:230px;
    .buts {
      color: #1890ff;
      cursor: pointer;
    }
    .item {
      // width: 1/3;
      cursor: pointer;
      .item-tit {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .item-add {
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 30px;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 10px;
      }
    }
    .total {
      width: 100%;
      display:flex;
      // padding: 0 30px;
      .items {
        width: 33.3%;
        padding: 50px 0 30px;
        padding-left: 40px;
        .bold {
          margin: 20px 0;
          font-weight: bold;
        }
        a {
          color: #1890ff;
        }
      }

    }
  }
</style>
